import axios from 'axios'

export default {


    async createAssignmentsInBulkForGroup({ title='',group_id, start_date, num_assignments, recurring_week_day }) {
        return await axios.post('/institution/group/assignments/bulk', {
            title,
            group_id : group_id,
            start_date : start_date,
            num_assignments : num_assignments,
            recurring_week_day : recurring_week_day,
        })
    },

    async createGroupAssigmment({ title, type, due_date, group_id }) {
        return await axios.post('/institution/group/assignment', {
            title : title,
            type : type,
            due_date : due_date,
            group_id : group_id
        })
    },

    async createInstitutionHoliday({ title, start, end }) {
        return await axios.post('/institution/holiday', {
            title : title,
            start : start,
            end : end
        })
    },

    async createInstitutionPermissions({ data }) {
        return await axios.post('/institution/permissions/group', data)
    },

    async createInstitutionUser({ institution_id, firstname, lastname, email, password, permission_group_id }) {
        return await axios.post(`/institution/users`, {
            institution_id : institution_id,
            firstname : firstname,
            lastname : lastname,
            email : email,
            password : password,
            permission_group_id : permission_group_id
        })
    },

    async fetchInstitutionHolidays() {
        return await axios.get('/institution/holidays')
    },

    async getAdminUsers(institution_id, permission_group_id, params = {}) {
        const queryParams = new URLSearchParams({
            permission_group_id: permission_group_id,
            ...params
        }).toString()
        return await axios.get(`/admin/institution/${institution_id}/admins?${queryParams}`)
    },

    async getExamGroups() {
        return await axios.get('/institution/groups/exams')
    },

    async getInstitutionSettings() {
        return await axios.get('/institution/settings')
    },

    async getInstitutionPermissionGroups({ institution_id }) {
        return await axios.get(`/institution/${institution_id}/permissions/groups`)
    },

    async getInstitutionPermissions() {
        return await axios.get('/institution/permissions')
    },
    async getMaternityLeaveUsers({ start_date }) {
        // Interpolating a null start_date used to send the literal string
        // "null", which the API fed straight into a Postgres date comparison
        // and got back an empty list. Omit the param instead and let the API
        // apply its own "one year back" default.
        const params = start_date ? { start_date } : {}
        return await axios.get('/institution/maternity-leave', { params })
    },
    async getUserAssignmentPlan({ user_id, group_id }) {
        return await axios.get(`/assignments/group/${group_id}/assignment-plan/${user_id}`)
    },

    async logInAs({ user_id, log_back_to_previous=0 }) {
        return await axios.post('/users/log-in-as', {
            user_id : user_id,
            log_back_to_previous : log_back_to_previous
        })
    },

    async markStudentAsSelfStudy({ user_id, group_id }) {
        return await axios.put(`/user/selfstudy/${user_id}`, {
            group_id : group_id
        })
    },

    async removeInstitutionHoliday ({ schedule_id }) {
        return await axios.delete(`/institution/holiday/${schedule_id}`)
    },

    async saveInstitutionHoliday({ schedule_id, title, start, end }) {
        return await axios.put(`/institution/holiday/${schedule_id}`, {
            title : title,
            start : start,
            end : end
        })
    },

    async saveInstitutionPermissions({ permission_group_id, data }) {
        return await axios.put('/institution/permissions/group/'+permission_group_id, data)
    },

    async saveInstitutionSettings(settings) {
        return await axios.post('/institution/settings', settings)
    },

    async getInstitutionStatisticsAssignmentsBehind() {
        return await axios.get(`/statistics/institution/assignments-behind`)
    },

    async getInstitutionStatisticsMissingAssignments() {
        return await axios.get(`/statistics/institution/missing-assignments`)
    },

    async recalculateAssignmentsPlanForUser({ group_id, user_id }) {
        return await axios.post(`/institution/assignments/plan/user`, {
            group_id : group_id,
            user_id : user_id
        })
    },

    async recalculateAssignmentsPlansForGroup({ group_id }) {
        return await axios.post(`/institution/assignments/plans/group`, {
            group_id : group_id
        })
    },
    async registerMaternityLeave({ user_id, group_id, start_date, end_date }) {
        return await axios.post('/institution/maternity-leave', {
            user_id : user_id,
            group_id : group_id,
            start_date : start_date,
            end_date : end_date,
        })
    },

    async saveMoodleRelation({ moodle_course_id, replacement_group_id, create_sub_group, is_main_group }) {
        return await axios.put(`/institution/moodle/relation/${moodle_course_id}`, {
            replacement_group_id : replacement_group_id,
            create_sub_group : create_sub_group,
            is_main_group : is_main_group
        })
    },

    async saveUMSRelation({ uni_group_id, replacement_group_id }) {
        return await axios.put(`/institution/ums/relation/${uni_group_id}`, {
            replacement_group_id : replacement_group_id
        })
    },

    async searchMoodleGroups({ search_query }) {
        return await axios.post('/institution/moodle/groups/search', {
            search_query : search_query
        })
    },

    async searchUMSGroups({ search_query }) {
        return await axios.post('/institution/ums/groups/search', {
            search_query : search_query
        })
    },

    // The EFFECTIVE dropout flag (uni_allowed_institutions.enable_dropouts —
    // what the sync reads), not the enable-students-dropouts-ums row in
    // institution_settings, which nothing on the API side has ever read.
    async getUMSDropoutState({ institution_id }) {
        return await axios.get(institution_id
            ? `/institution/${institution_id}/ums/dropouts`
            : '/institution/ums/dropouts')
    },

    // Whether the nightly sweep may drop out students UMS has stopped listing
    // on a hold at all. Sibling of enableStudentDropouts: same table, same
    // "write every row for the institution" shape.
    async setRemoveUnenrolled({ group_institution_id, remove_unenrolled }) {
        return await axios.post('/institution/ums/remove-unenrolled', {
            group_institution_id,
            remove_unenrolled
        })
    },

    // Queues a sync. The run itself takes ~10 minutes and is executed by the
    // cron:ums-sync-requests scheduler job, so poll getUMSSyncStatus for the
    // outcome rather than waiting on this call.
    async requestUMSSync() {
        return await axios.post('/institution/ums/sync', {})
    },

    async getUMSSyncStatus() {
        return await axios.get('/institution/ums/sync')
    },

    // Finds UMS-linked classes by name or hold code. Not searchUMSGroups:
    // that one joins through uni_allowed_institutions, whose codes do not
    // match the department code Frederiksberg VUC's holds actually carry, so
    // it returns nothing for the tenant this tool is for.
    async searchUMSHolds({ q, institution_id }) {
        return await axios.get('/institution/ums/holds/search', {
            params : { q : q, institution_id : institution_id }
        })
    },

    // Read-only preview: who does UMS/Ludus have on this hold that we do not,
    // and vice versa. Writes nothing. `refresh` bypasses the server-side feed
    // cache, for "I just changed something in Ludus and want to see it now".
    async getUMSHoldDiff({ group_id, refresh = false }) {
        return await axios.get(`/groups/${group_id}/ums/diff`, {
            params : refresh ? { refresh : 1 } : {}
        })
    },

    // Applies ONLY the ids the admin just saw in the preview. The server
    // re-derives the diff and intersects, so anything that changed in the
    // meantime comes back under `skipped` instead of being acted on.
    async reconcileUMSHold({ group_id, remove_user_ids = [], add_user_ids = [] }) {
        return await axios.post(`/groups/${group_id}/ums/reconcile`, {
            remove_user_ids : remove_user_ids,
            add_user_ids : add_user_ids
        })
    },

    async setNewPassword({ user_id }) {
        if(!user_id) return 0
        return await axios.post('/users/reset-password', {
            user_id
        });
    },
    async setInstitutionGropsSettings({ setting, value }) {
        if (!setting) return 0
        return await axios.post('/institution/groups/setting', {
            setting,
            value
        })
    },

    async enableStudentDropouts({ group_institution_id, enable_dropouts }) {
        return await axios.post('/institution/enable-dropouts', {
            group_institution_id,
            enable_dropouts
        })
    },

    async mergeUsers({ target_user_id, source_user_id }) {
        return await axios.post('/admin/users/merge', {
            target_user_id: target_user_id,
            source_user_id: source_user_id
        })
    },

    async fixStudentFRBVUC({ student_administration_id, institution_id }) {
        return await axios.post('/admin/fix-student-frbvuc', {
            student_administration_id: student_administration_id,
            institution_id: institution_id
        })
    }

}
